module.exports = __webpack_public_path__ + "static/img/A50.1f094e71.jpg";